import { render, staticRenderFns } from "./SmartMatchTab.vue?vue&type=template&id=63d84ed1&scoped=true"
import script from "./SmartMatchTab.vue?vue&type=script&lang=ts"
export * from "./SmartMatchTab.vue?vue&type=script&lang=ts"
import style0 from "./SmartMatchTab.vue?vue&type=style&index=0&id=63d84ed1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d84ed1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d84ed1')) {
      api.createRecord('63d84ed1', component.options)
    } else {
      api.reload('63d84ed1', component.options)
    }
    module.hot.accept("./SmartMatchTab.vue?vue&type=template&id=63d84ed1&scoped=true", function () {
      api.rerender('63d84ed1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/SmartMatchTab.vue"
export default component.exports